import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const laminaDeVento: TechniqueDefinition = {
  id: "lamina_de_vento",
  name: "Lâmina de Vento",
  description: "Fires a compressed blade of wind in a straight line.",
  family: "elemental_ninjutsu",
  proficiency: "ninjutsu",
  targeting: "projectile",
  behavior: { kind: "damage" },
  levels: {
    1: {
      chakraCost: 16,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 1,
      power: 8,
      attackCoefficient: 1.1,
    },
    2: {
      chakraCost: 16,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 1,
      power: 9,
      attackCoefficient: 1.14,
    },
    3: {
      chakraCost: 17,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 1,
      power: 10,
      attackCoefficient: 1.19,
    },
    4: {
      chakraCost: 17,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 1,
      power: 11,
      attackCoefficient: 1.23,
    },
    5: {
      chakraCost: 18,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 2,
      power: 12,
      attackCoefficient: 1.28,
    },
    6: {
      chakraCost: 18,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 2,
      power: 13,
      attackCoefficient: 1.32,
    },
    7: {
      chakraCost: 19,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 2,
      power: 14,
      attackCoefficient: 1.37,
    },
    8: {
      chakraCost: 20,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 2,
      power: 15,
      attackCoefficient: 1.41,
    },
    9: {
      chakraCost: 21,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 2,
      power: 16,
      attackCoefficient: 1.46,
    },
    10: {
      chakraCost: 22,
      cooldownMs: 4_000,
      range: 208,
      maxTargets: 3,
      power: 16,
      attackCoefficient: 1.5,
    },
  },
  visual: { effectId: 164, castEffectId: null, missileId: 30 },
};
